import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { apisiseci } from "../../../../../../api";
import { AttendanceLocalDepartment } from "../../../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentQueueServiceTimeException } from "../../../../../../../@types/attendance-local-department-queue-service-time-exception";

export type AttendanceLocalDepartmentQueueServiceTimeExceptionCreateData = Pick<
    AttendanceLocalDepartmentQueueServiceTimeException,
    | "fila"
    | "data"
    | "tempo_presencial"
    | "tempo_online"
    | "horario_especial_agendamento"
    | "hora_inicio_agendamento"
    | "hora_fim_agendamento"
    | "intervalo_hora_inicio_agendamento"
    | "intervalo_hora_fim_agendamento"
    | "horario_especial_diario"
    | "hora_inicio_diario"
    | "hora_fim_diario"
    | "intervalo_hora_inicio_diario"
    | "intervalo_hora_fim_diario"
> & {
    setor: AttendanceLocalDepartment["id"];
    servico: AttendanceLocalDepartmentQueueServiceTimeException["servico"]["id"];
}

export function useAttendanceLocalDepartmentQueueServiceTimeExceptionCreate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "queue", "service-time-exception", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentQueueServiceTimeExceptionCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentQueueServiceTimeException>(
                '/cms/excecao_horario_agendamento/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'department', 'queue', 'service-time-exception', 'list']
            });
            toast.success("Exceção de tempo de serviço criado com sucesso!");
            history.replace({
                pathname: history.location.pathname.replace(/\/novo$/, ""),
                state: { showSuccessAlert: true }
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
